/**
 * @flow
 * @relayHash 4db5b77b714be164d3660faf22d6d8f7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type VoidJournalEntryInput = {|
  id: string
|};
export type VoidJournalEntryMutationVariables = {|
  input: VoidJournalEntryInput
|};
export type VoidJournalEntryMutationResponse = {|
  +voidJournalEntry: {|
    +journalEntryEdge: {|
      +node: {|
        +id: string,
        +status: JournalEntryStatus,
        +voidedAt: ?any,
      |}
    |}
  |}
|};
export type VoidJournalEntryMutation = {|
  variables: VoidJournalEntryMutationVariables,
  response: VoidJournalEntryMutationResponse,
|};
*/


/*
mutation VoidJournalEntryMutation(
  $input: VoidJournalEntryInput!
) {
  voidJournalEntry(input: $input) {
    journalEntryEdge {
      node {
        id
        status
        voidedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VoidJournalEntryInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "voidJournalEntry",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VoidJournalEntryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "journalEntryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "JournalEntryEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "JournalEntry",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "voidedAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VoidJournalEntryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "VoidJournalEntryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "VoidJournalEntryMutation",
    "id": null,
    "text": "mutation VoidJournalEntryMutation(\n  $input: VoidJournalEntryInput!\n) {\n  voidJournalEntry(input: $input) {\n    journalEntryEdge {\n      node {\n        id\n        status\n        voidedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd02ebb2ff0d9119de66e50e5c3197ccc';
module.exports = node;
